import { render, staticRenderFns } from "./qa-dialog.vue?vue&type=template&id=251cb4fa&scoped=true"
import script from "./qa-dialog.vue?vue&type=script&lang=js"
export * from "./qa-dialog.vue?vue&type=script&lang=js"
import style0 from "./qa-dialog.vue?vue&type=style&index=0&id=251cb4fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251cb4fa",
  null
  
)

export default component.exports